var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLikeMutualMatchNoShadow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLikeMutualMatchNoShadow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.5056966,453 C44.4566447,453 45.411085,453.38844 46.1333785,454.164263 L46.1333785,454.164263 L46.9996897,455.097639 L47.8660162,454.169176 C49.3105881,452.617496 51.6720146,452.617531 53.1165711,454.169176 C54.561143,455.720822 54.561143,458.212866 53.1165711,459.764514 C51.1506994,461.87612 49.1857156,463.990084 47.2198592,466.101643 C47.1619953,466.164428 47.0815039,466.2 46.9973004,466.2 C46.9130969,466.2 46.8326055,466.164428 46.7747417,466.101643 L46.7747417,466.101643 L40.8828086,459.759594 C39.439891,458.206745 39.4382368,455.715885 40.8828086,454.164263 C41.6050869,453.388438 42.5547485,453 43.5056966,453 Z M53.1499123,447.8 C53.5989711,447.8 54.049679,447.976564 54.3907621,448.329211 L54.3907621,448.329211 L54.7998535,448.753472 L55.2089521,448.331443 C55.891111,447.626135 57.0062291,447.62615 57.6883808,448.331443 C58.3705397,449.036737 58.3705397,450.169485 57.6883808,450.874779 C56.7600525,451.8346 55.8321435,452.795493 54.9038224,453.755292 C54.8764978,453.783831 54.838488,453.8 54.7987252,453.8 C54.7589624,453.8 54.7209526,453.783831 54.693628,453.755292 L54.693628,453.755292 L51.9113263,450.872543 C51.2299485,450.166702 51.2291674,449.034493 51.9113263,448.329211 C52.2524021,447.976563 52.7008534,447.8 53.1499123,447.8 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Congratulaion-Favourite",
    transform: "translate(-39.000000, -447.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icLikeMutualMatchNoShadow",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLikeMutualMatchNoShadow);
export default __webpack_public_path__ + "static/media/icLikeMutualMatchNoShadow.49eabf87db063ae1ad8470114d3b4f65.svg";
export { ForwardRef as ReactComponent };